import { render, staticRenderFns } from "./menuBox.vue?vue&type=template&id=53f69490&scoped=true"
import script from "./menuBox.vue?vue&type=script&lang=js"
export * from "./menuBox.vue?vue&type=script&lang=js"
import style0 from "./menuBox.vue?vue&type=style&index=0&id=53f69490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f69490",
  null
  
)

export default component.exports